/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const DefaultColumns = [
  {
    title: 'Aplicación',
    dataIndex: 'application',
    key: 'application',
  },
  {
    title: 'Nombre del rol',
    dataIndex: 'rol',
    key: 'rol',
  },
  {
    title: 'Alias',
    dataIndex: 'alias',
    key: 'alias',
  },
  /*{
    title: 'Fecha de creación',
    dataIndex: 'creationDate',
    key: 'creationDate',
  },*/
  {
    title: 'Acciones',
    dataIndex: 'actions',
    key: 'actions',
  } 
];

export const CrudCheckboxOptions = [
  {
    label: 'Crear',
    value: 'create',
  },
  {
    label: 'Eliminar',
    value: 'delete',
  },
  {
    label: 'Modificar',
    value: 'edit',
  },
  {
    label: 'Ver',
    value: 'view',
  },
];

export const RolesLocaleTable = {
  emptyText: 'No se encontraron roles para esta licencia. Selecciona una licencia.',
  pageSize: 10,
};

export const PatternValidatorForm = {
  alphaNumeric: /^[A-Za-záéíóúÁÉÍÓÚñÑ0-9-_\s]+$/g,
};

export const FormValidators = {
  maxLengthBase: 50,
};

export const EventType = {
  expiredAuth: 'EXPIRED_AUTHORIZATION',
  servicesNotAvailable: 'SERVICES_NOT_AVAILABLE',
};
